import { h } from 'preact';
import { useState } from 'preact/hooks';
import { getChatbotUrl } from '../../../_services/chatbot-service';
import Logo from '../../../_common/components/img/ilerna-rebranding.svg';
import './ChatbotFloating.scss';

export default function ChatbotFloating({ token }) {
    const [isOpen, setIsOpen] = useState(false);
    const [iframeUrl, setIframeUrl] = useState('');
    const isPreprodEnvironment = [
        'localhost',
        'localhost.ilerna.com',
        'pre-account.ilerna.com'
    ].includes(window.location.hostname);

    if (!token || !isPreprodEnvironment) return null;

    const openChatbot = () => {
        if (iframeUrl) {
            setIsOpen(true);
            return;
        }

        try {
            setIframeUrl(getChatbotUrl(token));
            setIsOpen(true);
        } catch (exception) {
            console.error('No se ha podido abrir el chatbot.', exception);
        }
    };

    const closeChatbot = () => {
        setIsOpen(false);
    };

    return (
        <div className="chatbot-floating">
            <button
                type="button"
                className="chatbot-floating__button"
                onClick={openChatbot}
                aria-label="Abrir Chatbot iLERNA"
                title="Abrir Chatbot iLERNA"
            >
                <i className="far fa-comment-dots" aria-hidden="true" />
            </button>

            {iframeUrl && (
                <div
                    className={`chatbot-floating__overlay${isOpen ? '' : ' chatbot-floating__overlay--hidden'}`}
                    role="presentation"
                    onClick={closeChatbot}
                >
                    <div
                        className="chatbot-floating__modal"
                        role="dialog"
                        aria-modal="true"
                        aria-label="Chatbot iLERNA"
                        onClick={event => event.stopPropagation()}
                    >
                        <header className="chatbot-floating__header">
                            <img src={Logo} className="logo" alt="iLERNA" />
                            <button type="button" onClick={closeChatbot} aria-label="Cerrar chatbot">
                                <i className="fal fa-times" aria-hidden="true" />
                            </button>
                        </header>
                        <div className="chatbot-floating__body">
                            <iframe src={iframeUrl} title="Chatbot iLERNA" allow="clipboard-write" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
